import { render, staticRenderFns } from "./AcceptTermsOfUsageField.vue?vue&type=template&id=2dbb74c3&scoped=true&"
import script from "./AcceptTermsOfUsageField.vue?vue&type=script&lang=js&"
export * from "./AcceptTermsOfUsageField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb74c3",
  null
  
)

export default component.exports